import { compose } from 'recompose';
import { queryGetPerDiemEligibleUsersGQL } from '../graphql/allPerDiemUserQuery';
import UserPicker from '..';

const enhance = compose(queryGetPerDiemEligibleUsersGQL);

export default enhance(UserPicker);
